export default {"src":"https://fishbrain.com/_next/static/media/waypoints.bfe1df9b.svg","height":34,"width":44,"blurWidth":0,"blurHeight":0};